import { format } from "date-fns";
import { complexQuery, getUserId } from "../../../Utils/Common/Library";
import { constants } from "../Dimension/Data/QueryConstants";
import { setRecords } from "../../../Redux/Actions/TeamPlanActions";
import store from "../../../Redux/Store";
import { applyFiltersToData, applySortToData } from "./helpers";

export function filterData(queryData, role) {
  if (!queryData) return [];

  if (role) {
    const userId = getUserId();
    queryData = queryData.filter((item) => {
      let type = [];
      console.log("items is: ", item);
      for (let i = 0; i < item.Dimensions.length; i++) {
        const { AppraiserID, ReviewerID } = item.Dimensions[i];
        if (userId === AppraiserID) {
          type.push("Appraiser");
        }
        if (userId === ReviewerID) {
          type.push("Reviewer");
        }
      }
      return type.includes(role === "R" ? "Reviewer" : "Appraiser");
    });
  }

  const statusArray = [
    "Assessment Initiated",
    "Appraiser Assessment Due",
    "Reviewer Assessment Due",
    "Moderator Action Due",
    "Appraisee Acceptance Due",
    "Assessment Closed",
  ];

  const dataMap = {};

  for (let i = 0; i < queryData.length; i++) {
    const doc = queryData[i];
    const documentId = doc.DocumentID;
    if (dataMap[documentId]) {
      const prevDoc = dataMap[documentId];
      const currDoc = doc;

      const prevStatus = prevDoc.CurrentStatus;
      const currStatus = currDoc.CurrentStatus;

      const prevIndex = statusArray.findIndex((s) => s === prevStatus);
      const currIndex = statusArray.findIndex((s) => s === currStatus);

      if (prevIndex !== -1 && currIndex !== -1) {
        if (currIndex > prevIndex) {
          dataMap[documentId] = currDoc;
        }
      }
    } else {
      dataMap[documentId] = doc;
    }
  }
  queryData = Object.values(dataMap);

  return queryData;
}

export function generateUserType(userId, dimensions) {
  let type = [];
  if (dimensions?.length > 0) {
    for (let i = 0; i < dimensions.length; i++) {
      const { AppraiserID, ReviewerID } = dimensions[i];
      if (userId === AppraiserID) {
        type.push("Appraiser");
      }
      if (userId === ReviewerID) {
        type.push("Reviewer");
      }
    }
  }

  type = [...new Set(type)];
  return type.join(",") || "N/A";
}

export async function fetchData({
  userId,
  relationType,
  filterModel,
  sortModel,
}) {
  const storeRecords = store.getState().TeamPlanReducer.records;

  if (
    (Object.keys(filterModel).length > 0 || sortModel.length > 0) &&
    storeRecords[userId]
  ) {
    const allRecords = Object.values(storeRecords).flat();
    const filtered = applyFiltersToData(allRecords, filterModel);
    const sorted = applySortToData(filtered, sortModel);
    return sorted;
  } else {
    try {
      const rowToMapData = [
        "PlanPeriod",
        "AppraiseeUserEmployeeCode",
        "AppraiseeUserFullName",
        "GoalSettingStatus",
        "CurrentStatus",
        "PlanStartDate",
        "PlanEndDate",
        "AppraiseeUserID",
        "UserType",
        "HIDDENval",
      ];
      const results = await complexQuery({
        QueryName: constants.FindAllLineAndFunctionalEPPByAppraiserOrReviewerV2,
        otherData: {
          AppraiserUserID: userId,
          RelationshipType: relationType,
          Limit: 100,
          Offset: 0,
        },
        RequiredFields: [],
      });
      const mappedRows = results.map((item) => {
        const newItem = {};
        rowToMapData.forEach((rowField) => {
          if (rowField === "UserType") {
            newItem[rowField] = generateUserType(getUserId(), item.Dimensions);
          } else if (rowField === "HIDDENval") {
            newItem[rowField] = item;
          } else if (rowField.includes("Date")) {
            newItem[rowField] = format(
              parseInt(item[rowField]),
              "MMM dd, yyyy"
            );
          } else if (typeof rowField === "string") {
            newItem[rowField] = item[rowField];
          } else {
            newItem[rowField] = "";
          }
        });
        return newItem;
      });

      // Adding a temp filter only for PlanPeriod
      let filtered = mappedRows;
      if (filterModel.PlanPeriod) {
        const periodFiltered = { PlanPeriod: filterModel.PlanPeriod };
        filtered = applyFiltersToData(mappedRows, periodFiltered);
      }
      const users = {};
      filtered.forEach((row) => {
        users[row.AppraiseeUserID] = row;
      });

      const records = Object.values(users);
      store.dispatch(setRecords({ ...storeRecords, [userId]: records }));

      if (Object.values(filterModel).length > 0 || sortModel.length > 0) {
        const filtered = applyFiltersToData(records, filterModel);
        const sorted = applySortToData(filtered, sortModel);
        return sorted;
      }

      return records;
    } catch (error) {
      console.error("One or more requests failed:", error);
      return [];
    }
  }
}
